/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
import ExclusiveContentMenu from 'components/molecules/exclusive_content_menu';
import React, { useEffect, useState } from 'react';
import { getCurriculum } from 'services/actions/get_curriculum';
import Loader from 'components/atoms/loader';
import ModalJobVacancy from 'components/atoms/modal_job_vacancy';
import Clippings from 'components/organisms/Clippings';
import { Container } from './styles';

interface JobVacancyProps {
  params: {
    page?: string;
  };
}

const JobVacancy = (props: JobVacancyProps) => {
  const { params } = props;
  const [curriculumData, setCurriculumData] = useState<any>({});
  const [page, setPage] = useState<string>(
    params?.page ? params?.page : 'clipping_policia_federal',
  );
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [estado, setEstado] = useState<string>();
  const [dadosCurriculo, setDadosCurriculo] = useState<any>({});

  useEffect(() => {
    (async () => {
      if (page === 'bolsa_de_empregos') {
        const curriculumResponse = await getCurriculum();
        setCurriculumData(curriculumResponse);
        setLoading(curriculumResponse.status !== 200);
      }
    })();
  }, [page]);

  useEffect(() => {
    document.title = 'Conteúdo Exclusivo - ConLicitação';
  }, []);

  return (
    <Container>
      <div className="page-container">
        <div className="container p-4">
          <div className="row">
            <div className="col-md-3">
              <ExclusiveContentMenu page={page} setPage={setPage} />
            </div>
            {page === 'bolsa_de_empregos' ? (
              <div className="col-md-9 mt-md-0 mt-3">
                <h3>Bolsa de Empregos</h3>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <div className="card mb-3">
                      <div className="card-body d-md-flex flex-column flex-md-row justify-content-between">
                        <div>
                          <p className="mr-3">
                            Na Bolsa de Empregos, você pode disponibilizar oportunidades de empregos
                            voltadas à área de <br /> licitações públicas.
                          </p>
                        </div>
                        <div className="button-container">
                          <a
                            href="https://conlicitacao.com.br/bolsa-de-emprego/#1637866437846-0f4824f3-9b48"
                            className="btn btn-success"
                          >
                            Cadastrar Vaga
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="curriculos">
                  <h4>Currículos cadastrados</h4>
                  <hr />
                  {loading ? (
                    <Loader />
                  ) : (
                    <div className="conteudo table-responsive">
                      {curriculumData && curriculumData.data?.curriculo ? (
                        <table width="100%">
                          <tbody>
                            {Object.entries(curriculumData.data?.curriculo)?.map(
                              ([categoria, curriculos]: any, index: number) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <th colSpan={4} className="titulo">
                                      <h4 className="font-weight-bold">{categoria}</h4>
                                    </th>
                                  </tr>

                                  {curriculos &&
                                    Array.isArray(curriculos) &&
                                    curriculos.map((curriculo: any, innerIndex: number) => (
                                      <table className="table" key={innerIndex}>
                                        <thead>
                                          <tr>
                                            <th scope="col">Nome</th>
                                            <th scope="col">Cidade</th>
                                            <th scope="col">Vaga pretendida</th>
                                            <th scope="col" />
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td width="40%">
                                              <button
                                                type="button"
                                                className="btn btn-link btn-sm p-0 vaga-tooltip"
                                                onClick={() => {
                                                  setShowModal(true);
                                                  setDadosCurriculo(curriculo);
                                                  setEstado(categoria);
                                                }}
                                              >
                                                {curriculo?.curriculos_nome}
                                              </button>
                                            </td>
                                            <td width="30%">{curriculo?.curriculos_cidade}</td>
                                            <td width="30%">
                                              <button
                                                type="button"
                                                className="btn btn-link btn-sm p-0 vaga-tooltip"
                                                onClick={() => {
                                                  setShowModal(true);
                                                  setDadosCurriculo(curriculo);
                                                  setEstado(categoria);
                                                }}
                                              >
                                                {curriculo?.curriculos_vaga}
                                              </button>
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                className="btn btn-link btn-sm p-0 vaga-tooltip"
                                                onClick={() => {
                                                  setShowModal(true);
                                                  setDadosCurriculo(curriculo);
                                                  setEstado(categoria);
                                                }}
                                              >
                                                <i className="material-icons">search</i>
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    ))}
                                </React.Fragment>
                              ),
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <p>Nenhum currículo cadastrado ainda.</p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <Clippings />
            )}
          </div>
        </div>
      </div>
      <ModalJobVacancy
        showModal={showModal}
        dadosCurriculo={dadosCurriculo}
        setShowModal={setShowModal}
        estado={estado}
      />
    </Container>
  );
};

export default JobVacancy;
